import workspaceQuery from 'graphql/queries/supplier/AccountStatusWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/supplier/AccountStatusListQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/AccountStatusQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/AccountStatusDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/AccountStatusMutation.graphql';
import fragment from 'graphql/fragments/supplier/AccountStatusFragment.graphql';

const SupplierAccountStatus = {
  type: 'SupplierAccountStatus',
  title: 'Supplier Account Status',
  formUrl: '/Suppliers/AccountStatus/Details/',
  formTitle: 'Supplier Account Status',
  workspaceUrl: '/Suppliers/AccountStatus/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
  },
  fragment,
  screenReference: 'SUPPLIER_ACCOUNT_STATUS',
};

export default SupplierAccountStatus;
